import { useEffect, useState } from 'react'
import { supabase } from './supabase'

export type UserRole = 'user' | 'admin' | 'superadmin'

export function useRole() {
    const [role, setRole] = useState<UserRole>('user')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function fetchRole() {
            try {
                const { data, error } = await supabase
                    .schema('basejump')
                    .from('current_user_role')
                    .select('role')
                    .single()

                if (error) {
                    console.error('Error fetching role:', error)
                    // For PGRST116 error (no rows found), we keep the default 'user' role
                    if (error.code === 'PGRST116') {
                        // If user is authenticated but doesn't have a role entry, default to 'user'
                        setRole('user')
                    }
                    setLoading(false)
                    return
                }

                setRole((data?.role as UserRole) || 'user')
            } catch (error) {
                console.error('Error in fetchRole:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchRole()
    }, [])

    const isSuperAdmin = role === 'superadmin'
    const isAdmin = role === 'admin' || role === 'superadmin'

    return {
        role,
        loading,
        isSuperAdmin,
        isAdmin,
    }
} 